import React, { useMemo } from "react";
import { motion } from "framer-motion";

const TradingChartXY = () => {
  const priceLabels = [5500, 5000, 4500, 4000, 3500, 3000, 2500, 2000];
  
  const candleData = useMemo(() => {
    return Array.from({ length: 22 }, (_, i) => ({
      id: i,
      // Y-axis par position (Center mein rakhne ke liye 40% to 70% ke darmiyan)
      positionY: 40 + Math.sin(i * 0.7) * 15 + Math.random() * 10,
      // Candle ki height max 2 inches (around 50-70px)
      bodyHeight: 20 + Math.random() * 40, 
      isUp: Math.random() > 0.4,
      delay: i * 0.05
    }));
  }, []);

  return (
    <div className=" w-full h-[400px] bg-[#131722] rounded-3xl p-6 border border-slate-800 flex shadow-2xl overflow-hidden">
      
      {/* 1. Main Chart Area */}
      <div className="relative flex-1 h-full border-b border-l border-slate-700/50">
        
        {/* Grid Background */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" 
             style={{ backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

        {/* Floating Candles Container */}
        <div className="relative w-full h-full flex items-center">
          {candleData.map((candle, i) => (
            <div key={candle.id} className="relative h-full flex-1 flex flex-col items-center">
              
              {/* Candle Wrapper - Positioned vertically according to price */}
              <motion.div 
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: candle.delay }}
                className="absolute w-full flex flex-col items-center"
                style={{ bottom: `${candle.positionY}%` }}
              >
                {/* Wick (Thin line) - Floating */}
                <div className={`w-[1px] h-20 absolute ${candle.isUp ? 'bg-emerald-500' : 'bg-rose-500'} opacity-30`} 
                     style={{ top: '-10px' }} />

                {/* Candle Body - Max 2 inches style */}
                <motion.div
                  initial={{ scaleY: 0 }}
                  whileInView={{ scaleY: 1 }}
                  transition={{ duration: 0.4, delay: candle.delay }}
                  className={`w-[70%] max-w-[10px] rounded-[1px] z-10 shadow-lg ${
                    candle.isUp ? 'bg-[#26a69a]' : 'bg-[#ef5350]'
                  }`}
                  style={{ height: `${candle.bodyHeight}px`, transformOrigin: 'center' }}
                />

                {/* Point P (Last Indicator) */}
                {i === candleData.length - 1 && (
                  <div className="absolute -right-1 z-20">
                    <span className="relative flex h-3 w-3">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500 shadow-[0_0_10px_#3b82f6]"></span>
                    </span>
                  </div>
                )}
              </motion.div>
            </div>
          ))}
        </div>

        <div className="absolute bottom-2 left-2 text-[10px] font-bold text-slate-600">O</div>
      </div>

      {/* 2. Right Side Vertical Values */}
      <div className="w-14 h-full border-l border-slate-800/50 flex flex-col justify-between py-1 pl-3">
        {priceLabels.map((val) => (
          <span key={val} className="text-[9px] font-bold text-slate-500 font-mono italic">
            {val}
          </span>
        ))}
      </div>

      {/* Live Label Overlay */}
      <div className="absolute top-6 left-10 flex items-center gap-2">
        <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
        <span className="text-[10px] font-black text-slate-400 tracking-[0.2em] uppercase">Market Live</span>
      </div>

    </div>
  );
};

export default TradingChartXY;